import api from "./api";
import currentUserId from "../reduxSaga/sagas/requests/currentUserId";
import UtilsUrl from "../utils/UtilsUrl";

// const BASE_BK_URL = "http://localhost:8082/gateway/finance/Banque"
// const BASE_BK_URL = "http://192.168.1.112:8082/gateway/finance/Banque"

class SpecificityService {
  getProductSpecificityByCategory(idUserCreation, idCategory) {
    return api.get(
      UtilsUrl.specificityURL() +
        "/getProductSpecificityByCategory/" +
        idUserCreation +
        "/" +
        idCategory
    );
  }

  deleteSpecificityCategoryById(idUserCreation, idSpecificity) {
    return api.get(
      UtilsUrl.specificityURL() +
        "/deleteSpecificityCategoryById/" +
        idUserCreation +
        "/" +
        idSpecificity
    );
  }

  addProductSpecificity(productSpecificityModel) {
    return api.post(
      UtilsUrl.specificityURL() + "/addProductSpecificity",
      productSpecificityModel
    );
  }
}

export default new SpecificityService();
